import Axios from 'axios'
import {donationUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_donations (context) {
    Axios.get(donationUrls.getAllDonations).then(function (response) {
      context.commit('GET_ALL_DONATIONS', response.data)
    })
  },
  get_donations (context, publicId) {
    Axios.get(donationUrls.getDonations + publicId).then(function (response) {
      context.commit('GET_DONATIONS', response.data)
    })
  },
  get_deleted_donations (context) {
    Axios.get(donationUrls.getDeletedDonation).then(function (response) {
      context.commit('GET_DELETED_DONATIONS', response.data)
    })
  },
  get_donation (context, publicId) {
    Axios.get(donationUrls.getDonation + publicId).then(function (response) {
      context.commit('GET_DONATION', response.data)
    })
  },
  donation_request_payment (context, data) {
    Axios.post(donationUrls.requestMpesa, data).then(function (response) {
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  post_public_donation (context, data) {
    Axios.post(donationUrls.postDonation, data).then(function (response) {
      window.open('/support-us-payment/' + response.data.donation_ref_code, '_self')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_donation (context, data) {
    Axios.post(donationUrls.editDonation, data).then(function () {
      context.dispatch('get_all_donations')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_donation (context, publicId) {
    var postData = {
      cancelled_by: localStorage.getItem('lkjhgfdsa')
    }
    Axios.post(donationUrls.deleteDonation + publicId, postData).then(function () {
      router.push({
        name: 'Donations'
      })
    })
  },
  restoreDonation (context, publicId) {
    Axios.get(donationUrls.restoreDonation + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_DONATIONS', response.data)
      router.push({
        name: 'Module.Donations'
      })
    })
  }
}
